module.exports = __webpack_public_path__ + "static/iphone-app-screens-3de38850780894d8919c0f579c01c4fc.png";